export enum USER_TYPE {
  ADMIN = 'Admin',
  CUSTOMER = 'Customer',
  FABRICATOR = 'Fabricator',
  FMI = 'Fmi',
  GLAZIER = 'Glazier',
  SUPPLIER = 'Supplier',
}
